<template>
  <div class="col-3 d-flex resizingCards">
    <div class="card shadow-sm mb-4 flex-grow-1">
      <div class="card-header font-weight-bold text-center">
        {{ device.data.name }}
      </div>
      <div class="card-body d-flex flex-column">
        <b-form-select v-model="selectedStatus" :options="statusOptions" class="text-center mb-3"></b-form-select>
        <div class="
            mb-3
            position-relative
            d-flex
            align-items-center
            justify-content-center
          " id="device-image">
          <button type="button" class="
              btn btn-primary
              overlay
              position-absolute
              rounded-circle
              align-items-center
              justify-content-center
              shadow
            " v-on:click="triggerImageSelector">
            <fa-icon :icon="['fas', 'edit']" class="text-white" fixed-width />
          </button>
          <img :src="image" alt="image" class="w-100" v-if="image !== ''" />
          <img src="https://via.placeholder.com/458x380/fff/000?text=Kein Bild" alt="image" class="w-100" v-else />
        </div>
        <b-form-file v-model="selectedImage" class="d-none" plain ref="imageSelector"></b-form-file>
        <div class="form-group">
          <label class="font-weight-bold">Sichtbarkeit</label>
          <b-form-checkbox v-model="visibility.comlineshop">
            ComLine Shop
          </b-form-checkbox>
          <b-form-checkbox v-model="visibility.clrent">
            CLRent
          </b-form-checkbox>
          <b-form-checkbox v-model="visibility.ctoAtWebAndStore">
            CTO@Web/-Store
          </b-form-checkbox>
          <b-form-checkbox v-model="visibility.debug">
            <b>DEBUG</b>
          </b-form-checkbox>
        </div>
      </div>
      <div class="card-footer">
        <router-link :to="{
          name: 'ConfigurationsView',
          params: { deviceId: device.id },
          query: { deviceName: encodeURI(device.data.name) },
        }" class="btn btn-outline-primary btn-block">Konfigurationen</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { firestore, storage } from "../plugins/firebase";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytesResumable,
} from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";

export default {
  name: "DeviceCardComponent",
  props: {
    device: Object,
  },
  watch: {
    selectedImage: function () {
      this.uploadImage()
        .then(() => {
          this.getImageUrl().then((imageUrl) => {
            this.image = imageUrl;
            this.saveImageUrlToDb(imageUrl).catch((error) =>
              console.error(error)
            ); // eslint-disable-line no-console
          });
        })
        .catch((error) => console.error(error)); // eslint-disable-line no-console
    },
    selectedStatus: function (selectedStatus) {
      const data = {
        status: selectedStatus,
      };
      updateDoc(doc(firestore, "devices", this.device.id), data).catch(
        (error) => console.error(error)
      ); // eslint-disable-line no-console
    },
    visibility: {
      handler(visibility) {
        const data = {
          visibility: visibility,
        };
        updateDoc(doc(firestore, "devices", this.device.id), data).catch(
          (error) => console.error(error)
        ); // eslint-disable-line no-console
      },
      deep: true,
    },
  },
  methods: {
    triggerImageSelector: function () {
      this.$refs.imageSelector.$el.click();
    },
    uploadImage: function () {
      return new Promise((resolve, reject) => {
        const config = {
          contentType: "image/jpeg",
        };

        const uploadTask = uploadBytesResumable(
          storageRef(storage, `deviceImages/${this.selectedImage.name}`),
          this.selectedImage,
          config
        );

        uploadTask.on(
          "state_changed",
          () => { },
          (error) => reject(error),
          () => {
            resolve();
          }
        );
      });
    },
    getImageUrl: function () {
      return getDownloadURL(
        storageRef(storage, `deviceImages/${this.selectedImage.name}`)
      );
    },
    saveImageUrlToDb: function (imageUrl) {
      const data = {
        image: imageUrl,
      };
      return updateDoc(doc(firestore, "devices", this.device.id), data);
    },
    resizeCard: function () {
      let cards = document.getElementsByClassName("resizingCards");
      let i = 0;
      if (window.innerWidth <= 991) {
        while (cards.length - i !== 0) {
          cards[i].classList.remove("col-3");
          cards[i].classList.add("col-6");
          i++;
        }
      } else {
        while (cards.length - i !== 0) {
          cards[i].classList.remove("col-6");
          cards[i].classList.add("col-3");
          i++;
        }
      }
    },
  },
  mounted() {
    if (this.device.data.visibility !== undefined) {
      this.visibility = this.device.data.visibility;
    }
    this.resizeCard();
    window.addEventListener("resize", this.resizeCard);
  },
  data() {
    return {
      image: this.device.data.image,
      selectedStatus: this.device.data.status,
      selectedImage: [],
      statusOptions: [
        {
          value: "",
          text: "-",
        },
        {
          value: "wartung",
          text: "In Wartung",
        },
        {
          value: "neu",
          text: "Neu",
        },
      ],
      visibility: {
        comlineshop: false,
        clrent: false,
        ctoAtWebAndStore: false,
        debug: true,
      },
    };
  },
};
</script>

<style scoped>
#device-image .overlay {
  display: none;
  width: 56px;
  height: 56px;
}

#device-image:hover .overlay {
  display: flex;
}
</style>